// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"2219359c","258":"a3f5677a","377":"adcebf8f","417":"4b3b6bfc","467":"a3357007","626":"e5e40771","870":"9fff47a1"}[chunkId] + ".js";
};